import '../css/Intro.css';
import { Link } from 'react-router-dom';
const Intro = ()=>{
    return(
        <>
        <section className="intro_main">
            <div className="intro_left">
                <div className="introPic_wrapper">
                    <img className="intro_pic" src="soumen.jpeg" alt="soumen gope's pic" />
                </div>
            </div>
            <div className="intro_right">
                <span> <img className="curveFlat" src="curveFlat_pf.svg" alt="curveFlat logo" /></span>
                <h1>Hello, my name is Soumen Gope. </h1>
                <h3>I'm a Full-Stack Developer.</h3>
                <p>
                With a foundation in Electrical Engineering and a passion for building modern, scalable web applications, I work with React.js, Redux, Node.js, SQL & NoSQL databases, and real-time technologies like Socket.io. I also have experience integrating Google Login, payment gateways, and AI/ML features. 
                My focus is on delivering fast, reliable, and user-centric solutions while continuously improving my skills.
                </p>
                <div className="cta_main">
                    <Link to="/projects">Projects</Link>
                    <Link to="/contacts">Contact Me</Link>
                </div>
            </div>
        </section>
        </>
    )
}
export default Intro;